import { useTranslation } from '@/i18n';
import { IconAi, TextLink } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo, useMemo } from 'react';
import styles from './OcrReflectionReferencedApplicationForm.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  id?: string;
  number?: string;
  title?: string;
};

const InnerOcrReflectionReferencedApplicationForm: FC<Props> = ({
  id,
  number,
  title,
}) => {
  const { t } = useTranslation();
  const applicationUrl = useMemo(() => {
    return `/approving_invoice_reports/${id}`;
  }, [id]);

  return (
    <div className={cx(styles['container'])}>
      <div className={cx(styles['header'])}>
        <IconAi size={16} />
        <span className={cx(styles['header-title'])}>
          {t('referenced_application_title')}
        </span>
      </div>

      <div className={cx(styles['rows'])}>
        <div className={cx(styles['row'])}>
          <div className={cx(styles['label'])}>
            {t('approving_invoice_report_detail_number')}
          </div>
          <div className={cx(styles['value'])}>
            {number ? (
              <TextLink href={applicationUrl} target='_blank'>
                {number}
              </TextLink>
            ) : (
              number
            )}
          </div>
        </div>

        <div className={cx(styles['row'])}>
          <div className={cx(styles['label'])}>
            {t('approving_invoice_report_detail_title')}
          </div>
          <div className={cx(styles['value'])}>
            <span className={cx(styles['title-text'])}>{title}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

InnerOcrReflectionReferencedApplicationForm.displayName =
  'InnerOcrReflectionReferencedApplicationForm';

export const OcrReflectionReferencedApplicationForm: FC<Props> = memo(
  InnerOcrReflectionReferencedApplicationForm
);
